import { Node } from "reactflow";
import { example, tutorial_sensecape, future_of_work, global_warming, demo_sensecape } from "../../user-study/script";
import { TaskValue } from "../../user-study/task-by-group";

export const initialSensecapeNodes = (task: TaskValue): Node[] => {

  if (task === TaskValue.Empty) { // Sensecape Demo
    return [];
  }

  if (task === TaskValue.Tutorial) { // interface tutorial
    return [
      {
        id: '1',
        type: 'memo',
        data: {
          placeholder: '',
          state: {
            title: 'Tutorial instruction',
            memo: tutorial_sensecape,
            isEditing: false,
          }
        },
        dragHandle: '.drag-handle',
        position: { x: 0, y: 0 },
      },
    ];
  }

  if (task === TaskValue.Demo) { // Sensecape Demo
    return [
      {
        id: '1',
        type: 'memo',
        data: {
          placeholder: '',
          state: {
            title: 'Welcome to Sensecape!',
            memo: demo_sensecape,
            isEditing: false,
          }
        },
        dragHandle: '.drag-handle',
        position: { x: 0, y: 0 },
      },
    ];
  }

  return [
    {
      id: '1',
      type: 'memo',
      data: {
        placeholder: '',
        state: {
          title: 'Task instruction',
          memo: task === TaskValue.AIFutureWork ? future_of_work : global_warming,
          // memo: example,
          isEditing: false,
        }
      },
      dragHandle: '.drag-handle',
      position: { x: 250, y: 0 },
    },
  ];
}